import { flatten, sortBy } from "lodash";
import { useEffect, useState } from "react";

import { storageRef } from "../firebase/config";

// NOTE (Kiluth demo): the original poster PDFs live in the Firebase Storage
// bucket `iadr-4224d.appspot.com`, whose billing account is now closed. Every
// Storage read fails (storage/quota-exceeded / HTTP 402). This hook is written
// to degrade gracefully — it always returns a clean array (never undefined
// entries) and a `loading` flag, so the poster pages can show a friendly
// notice instead of crashing to a blank screen.

const usePosters = () => {
  const [posters, setPosters] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const listFiles = async (category: number, path: string, event: string) => {
      try {
        const folderRef = storageRef.child(path);
        const results = await folderRef.listAll();

        const posters = await Promise.all(
          results.items.map(async (result: any) => {
            if (result.name.includes(".pdf")) {
              const name = result.name
                .replace(/_/g, " ")
                .replace(/Live/g, " ")
                .replace(".pdf", "");
              const code = name.split(" ")[0];
              const title = code + " " + name.split(" ").slice(1).join(" ");
              const author = name.split(" ").slice(1).join(" ");
              const image = await result.getDownloadURL();

              const file = {
                category,
                code,
                title,
                author,
                image,
                event,
              };

              return file;
            }
          })
        );

        // Drop non-PDF entries (undefined) so callers never touch a hole.
        return posters.filter(Boolean);
      } catch (error) {
        console.error(error);
        return [];
      }
    };

    const listAllPosters = async () => {
      const allPosters = await Promise.all([
        listFiles(1, "poster-presentations/category-1", "IADR"),
        listFiles(2, "poster-presentations/category-2", "IADR"),
        listFiles(3, "poster-presentations/category-3", "IADR"),
        listFiles(4, "poster-presentations/category-4", "IADR"),
        listFiles(1, "poster-presentations/competition-1", "SEAADE"),
        listFiles(2, "poster-presentations/competition-2", "SEAADE"),
        listFiles(3, "poster-presentations/competition-3", "SEAADE"),
        listFiles(4, "poster-presentations/competition-4", "SEAADE"),
        listFiles(5, "poster-presentations/competition-5", "SEAADE"),
        listFiles(6, "poster-presentations/competition-6", "SEAADE"),
      ]);

      setPosters(sortBy(flatten(allPosters).filter(Boolean), ["category", "code"]));
      setLoading(false);
    };

    listAllPosters();
  }, []);

  return { posters, loading };
};

export default usePosters;
